import React from "react";
import { ExternalLink, Shield } from "lucide-react";
import Typography from "../components/common/Typography";
import { Button } from "../components/common";

const SUPER_ADMIN_SHELL_URL = "https://internal.pedagogue.io";

const SuperAdminShellNotice: React.FC = () => {
  const handleOpenShell = () => {
    window.location.href = SUPER_ADMIN_SHELL_URL;
  };

  return (
    <div className="flex h-full min-h-[60vh] w-full flex-col items-center justify-center gap-8 bg-slate-50 px-6 py-10 text-center">
      <div className="flex h-20 w-20 items-center justify-center rounded-full bg-primary/10 text-primary">
        <Shield size={36} aria-hidden />
      </div>

      <div className="max-w-2xl space-y-4">
        <Typography variant="h2" weight="bold" className="text-textPrimary">
          Super Admin tools have moved
        </Typography>
        <Typography variant="p" className="text-lg text-slate-600">
          The embedded Super Admin console in the Admin app has been retired.
          Please manage demos, organisations, and audit logs from the dedicated
          shell at <span className="font-semibold">{SUPER_ADMIN_SHELL_URL}</span>.
        </Typography>
        <Typography variant="p" className="text-sm text-slate-500">
          Tip: Bookmark the new shell for quick access. Your Supabase login
          works across both applications.
        </Typography>
      </div>

      <Button
        variant="filled"
        size="large"
        className="flex items-center gap-2 bg-primary px-6 py-3 text-white"
        onClick={handleOpenShell}
      >
        Open Super Admin Shell
        <ExternalLink size={18} aria-hidden />
      </Button>
    </div>
  );
};

export default SuperAdminShellNotice;
